import { PropsWithChildren, FunctionComponent } from 'react'
import { connect, useSelector, shallowEqual } from 'react-redux'
import { Alert } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'

import {
    DfmCardType,
    DfmFeedbackSidebarWrapperType,
} from '~/apps/consumer/components/PartViewerModal/types'
import Box from '~/core/Box'
import Text from '~/core/Text'
import { hoverDfmCard, clickDfmCard } from '~/redux-modules/qmr-viewer/actions'
import {
    getSelectedDfmId,
    getHoveredDfmId,
} from '~/redux-modules/qmr-viewer/selectors'
import {
    DfmSnapshotType,
    ViewerStateType,
} from '~/redux-modules/qmr-viewer/types'
import { shipmentLines_shipment_shipmentLines_items_dfmFeedback_modelViewerSnapshots_snapshot as DfmSnapshotTypeGql } from '~/apps/consumer/pages/Orders/OrderDetailsPage/Queries/__generated__/shipmentLines'

import DfmFeedbackSidebar from './components/DfmFeedbackSidebar'

const DfmFeedbackSidebarWrapper: FunctionComponent<
    PropsWithChildren<DfmFeedbackSidebarWrapperType>
> = props => {
    const onHoverDfmFeedback = ({
        dfmFeedbackId,
    }: {
        dfmFeedbackId: string
    }) => {
        const action = hoverDfmCard({
            dfmId: dfmFeedbackId,
        })

        const { dispatch } = props

        dispatch(action)
    }

    const onSelectDfmFeedback = ({
        dfmFeedbackId,
        dfmSnapshot,
    }: {
        dfmFeedbackId: string
        dfmSnapshot?: DfmSnapshotTypeGql | null
    }) => {
        const action = clickDfmCard({
            dfmId: dfmFeedbackId,
            dfmSnapshot: (dfmSnapshot as DfmSnapshotType) || null,
        })

        const { dispatch } = props

        dispatch(action)
    }

    const activeDfmFeedbackId = useSelector(
        (state: Record<string, ViewerStateType>) =>
            getSelectedDfmId(state, props),
        shallowEqual,
    )

    const hoveredDfmFeedbackId = useSelector(
        (state: Record<string, ViewerStateType>) =>
            getHoveredDfmId(state, props),
        shallowEqual,
    )

    const { dfmFeedbacks } = props
    const dfmCardObj: DfmCardType[] = []

    props.dfmFeedbacks.forEach(item => {
        dfmCardObj.push({ [item.id]: false })
    })

    return (
        <>
            <Alert
                message={
                    <Text fontSize="14px" fontWeight={400} color="blackAlpha65">
                        The following warnings have been accepted.
                    </Text>
                }
                type="info"
                showIcon
                icon={<ExclamationCircleFilled />}
            />
            <Box direction="col" height="100%">
                <DfmFeedbackSidebar
                    dfmFeedbacks={dfmFeedbacks}
                    activeDfmFeedbackId={activeDfmFeedbackId}
                    hoveredDfmFeedbackId={hoveredDfmFeedbackId}
                    onHoverDfmFeedback={onHoverDfmFeedback}
                    onSelectDfmFeedback={onSelectDfmFeedback}
                    cardObj={dfmCardObj}
                />
            </Box>
        </>
    )
}

export default connect()(DfmFeedbackSidebarWrapper)
